/* eslint-disable react-hooks/exhaustive-deps */
import { IProduct_Category_Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { useIsMobile } from "@/hooks/useIsMobile";
import { RefObject, useEffect, useState } from "react";

export const useGetCategoryAdvanceStyle = (
  customize: IProduct_Category_Config_Customize,
  lebleRef: RefObject<HTMLDivElement | null>,
) => {
  const {
    gap: Pc_gap,
    gap_mobile,
    background_color,
    font_size,
    font_size_mobile,
    height,
    height_mobile,
    width,
    width_mobile,
  } = customize ?? {};
  const mobile = useIsMobile();
  const [lableHeight, setLableHeight] = useState(0);
  useEffect(() => {
    const el = lebleRef?.current;
    if (!el) return;
    const update = () => {
      const rect = el.getBoundingClientRect();
      setLableHeight(rect.height);
    };
    update();
    let obs: ResizeObserver | undefined;
    const onResize = () => update();

    if (typeof window !== "undefined") {
      if (typeof window.ResizeObserver !== "undefined") {
        obs = new ResizeObserver(() => update());
        obs.observe(el);
      } else {
        // Fallback for very old browsers
        window.addEventListener("resize", onResize);
      }
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", onResize);
      }
      obs?.disconnect();
    };
  }, [lebleRef, mobile]);
  const baseFontSize = mobile ? font_size_mobile : font_size;
  const advanceFontSize = (baseFontSize ?? 1) * 16;
  const gap = (mobile ? gap_mobile : Pc_gap) ?? 0;
  const customStyleMolie: React.CSSProperties = {
    height: "100%",
    width: width_mobile,
    backgroundColor: background_color,
    flexDirection: "column",
    gap,
    padding: 8,
    minHeight: height_mobile,
    justifyContent: "start",
  };
  const customStylePc: React.CSSProperties = {
    height: "100%",
    width: width,
    backgroundColor: background_color,
    flexDirection: "column",
    gap,
    padding: 16,
    minHeight: height,
    justifyContent: "start",
  };
  const advanceStyle = mobile ? customStyleMolie : customStylePc;
  const advancefullSize: React.CSSProperties = {
    width:
      Number(advanceStyle.minHeight) -
      Number(advanceStyle.padding) -
      (gap + lableHeight ? 20 : 0),
    height:
      Number(advanceStyle.minHeight) -
      Number(advanceStyle.padding) -
      (gap + lableHeight ? 20 : 0),
  };
  return {
    advancefullSize,
    advanceStyle,
    advanceFontSize,
  };
};
